<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
      :title="editType === 'phone' ? $lang('修改手机号') : $lang('修改代收货款')"
    >
      <div class="dialog-content">
        <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
          <div v-if="editType === 'phone'">
            <h3>{{ $lang('收件人信息') }}</h3>
            <div class="group-content">
              <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
                <BasePhoneInput :value="phoneVal2" v-model="formData.receiverMobilePhone"></BasePhoneInput>
              </el-form-item>
              <el-form-item :label="$lang('收件人备用手机号码')" prop="receiverTelphone">
                <BasePhoneInput :value="receiverTelphone" v-model="formData.receiverTelphone"></BasePhoneInput>
              </el-form-item>
            </div>
          </div>
          <div v-else>
            <h3>{{ $lang('代收货款信息') }}</h3>
            <div class="group-content">
              <el-form-item :label="$lang('运单号')" prop="waybillNo">
                <el-input v-model="formData.waybillNo"  :disabled="true" ></el-input>
              </el-form-item>
              <el-form-item :label="$lang('收件人姓名')" prop="receiverName">
                <el-input v-model="formData.receiverName"  :minlength="1" :maxlength="12" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
                <BasePhoneInput :value="phoneVal2" v-model="formData.receiverMobilePhone" :disabled="true"></BasePhoneInput>
              </el-form-item>
              <el-form-item :label="$lang('收件人城市')" prop="receiverCityName">
                <el-input v-model="formData.receiverCityName"  :minlength="1" :maxlength="12" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('收件区域名称')" prop="receiverAreaName">
                <el-input v-model="formData.receiverAreaName"  :minlength="1" :maxlength="12" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('收件人街道')" prop="receiverStreet">
                <el-input v-model="formData.receiverStreet"  :minlength="1" :maxlength="20" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('收件人详细地址')" prop="receiverDetailedAddress">
                <el-input v-model="formData.receiverDetailedAddress"   :disabled="true"></el-input>
              </el-form-item>
              <el-form-item style="width: auto;margin-top: 20px;" prop="formData.codNeed">
                  <el-switch
                    v-model="formData.codNeed"
                    :active-text="formData.codNeed? $lang('开启代收货款'): $lang('关闭代收货款')"
                    @change="checkCod"
                    >
                  </el-switch>
                </el-form-item>
              <el-form-item></el-form-item>
              <el-form-item :label="$lang('代收货款币别')" prop="currencyName" v-if="formData.codNeed">
                <el-select v-model="formData.currencyName" @change="changeCodCurrency" :disabled="true">
                  <el-option v-for="item in codCurrencyType" :key="item.code" :label="item.name" :value="item.code"  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$lang('代收货款金额')" prop="codMoney" v-if="formData.codNeed">
                <el-input
                  v-model="formData.codMoney"
                  :label="$lang('描述文字')"
                  :placeholder="$lang('请输入对应的金额')"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  @blur="getCalcHandler"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$lang('代收货款手续费')" prop="codFee" v-if="formData.codNeed">
                <el-input v-model="formData.codFee"  :minlength="1" :maxlength="12" :disabled="true"></el-input>
              </el-form-item>
            </div>
            <div class="tips" style="margin-top: 15px"><i style="margin-right: 5px; color: #f5222d">*</i>{{ $lang('代收货款修改需要审核通过后才会更改') }}</div>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button class="h40" @click="viewDialogVisible = false">{{ $lang('取 消') }}</el-button>
        <el-button type="primary" :loading="keyBtn" @click="editSave" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getsysCurrencyType, getCalc, customerCod } from '@api/module/customer'
import { RULES, phoneAndMobile } from '@utils/rules'

export default {
  name: 'WaybillEdit',
  props: {
    rowData: {
      type: Object,
      default: _ => { }
    },
    editType: {
      type: String,
      default: 'phone'
    },
    waybillLogStatus: {
      type: String,
      default: ''
    }
  },
  computed: {
    codDisabled () {
      const codMoney = this.rowData.codMoney
      const waybillLogStatus = +this.waybillLogStatus
      const flag = !codMoney || waybillLogStatus === 102
      // console.log(codMoney, waybillLogStatus, flag)
      return flag
    },
    userInfo() {
      return this.$store.state.base.user || {}
    },
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
  },
  watch: {
    rowData: {
      handler (val) {
        const { waybillNo, receiverName, receiverCityName, receiverAreaName, receiverStreet, receiverDetailedAddress, receiverMobilePhone, receiverTelphone, currencyName, currencyCode, codMoney, codFee, codNeed } = val
        if (codNeed === 1) {
          this.formData.codNeed = true
          this.isCanUPdate = true
        } else {
          this.formData.codNeed = false
          this.isCanUPdate = false
        }
        this.formData = {
          ...this.formData,
          receiverMobilePhone,
          receiverTelphone,
          currencyName,
          codMoney,
          codFee,
          waybillNo,
          receiverName,
          receiverCityName,
          receiverAreaName,
          receiverStreet,
          receiverDetailedAddress,
          currencyCode,
          beforeCodNeed: codNeed
        }
        console.log(val, 'after---->>', this.formData)
      },
      immediate: true,
      deep: true
    },
    viewDialogVisible (val) {
      this.$nextTick(_ => {
        this.$refs.sizeForm.clearValidate()
      })
    },
    async 'formData.codMoney'(val) {
      const { codMoney } = this.formData
      const { decimalPoint } = this.userInfo // 货币小数位数
      if (parseFloat(codMoney) > 0) {
        if (parseFloat(codMoney) > this.codNumber) {
          this.$message.error(this.$lang('代收货款金额超额，最高限额为') + this.codNumber)
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.')[1].length > (decimalPoint || 6)) {
          this.$message.error(`${this.$lang('代收货款不能超过')} ${decimalPoint || 6} ${this.$lang('位小数！请重新输入')}`)
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        }
      } else {
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    },
  },
  data () {
    return {
      viewDialogVisible: false,
      codCurrencyType: [],
      formData: {
        receiverMobilePhone: '',
        receiverTelphone: '',
        currencyName: '',
        codMoney: '',
        codFee: ''
      },
      rules: {
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [{ validator: phoneAndMobile }]
      },
      isCanUPdate: false,
      phoneVal2: '',
      receiverTelphone: '',
      keyBtn: false,
      codNumber: 3000
    }
  },
  created () {
    this.getCurrencyTypeList()
    this.queryCount()
  },
  methods: {
    async queryCount() {
      const res = await customerCod({ customerCode: this.userInfo.customerCode })
      if (res !== undefined && res.data !== null && res.data.isOpenCod === 1) {
        this.codNumber = res.data.maxCollectionMoney
      }
    },
    // 是否代收货款
    async checkCod(val) {
      console.log('🚀 ~ file: WaybillEdit.vue ~ line 205 ~ checkCod ~ val', val)
      this.formData.codNeed = val
      if (val) {
        const res = await customerCod({ customerCode: this.userInfo.customerCode })
        if (res !== undefined && res.data !== null && res.data.isOpenCod === 1) {
          // if (this.countryCode === 'UAE') {
          //   this.formData.currencyName = 'AED' // 代收货款币别
          //   this.formData.currencyCode = 'AED' // 代收货款币别code
          // } else {
          //   this.formData.currencyName = 'SAR' // 代收货款币别
          //   this.formData.currencyCode = 'SAR' // 代收货款币别code
          // }
          this.formData.currencyCode = this.codCurrencyType[0].code
          this.formData.currencyName = this.codCurrencyType[0].name
          this.codNumber = res.data.maxCollectionMoney
        } else {
          this.$message.error(this.$lang('您未开通代收货款服务，请联系合作网点！'))
        }
      } else {
        this.formData.currencyName = '' // 代收货款币别
        this.formData.currencyCode = '' // 代收货款币别code
        this.formData.codFee = '' // 代收货款手续费
      }
    },
    showDialog () {
      this.viewDialogVisible = true
    },
    hideDialog () {
      this.viewDialogVisible = false
    },
    async editSave () {
      if (this.formData.codNeed && !this.formData.codMoney) {
        this.$message.error(this.$lang('代收货款金额必须大于0'))
        return
      }
      await this.$refs.sizeForm.validate()
      const params = {
        ...this.formData,
        beforeCodMoney: +this.rowData.codMoney,
        afterCodMoney: +this.formData.codMoney
      }
      this.$emit('saveHandler', params, cb => {
        cb && this.hideDialog()
      })
    },
    async getCalcHandler () {
      if (this.formData.codMoney) {
        const res = await getCalc({ collectionfee: this.formData.codMoney })
        if (res && res.succ) {
          this.formData.codFee = res.data
        }
      }
    },
    // 获取币别
    async getCurrencyTypeList () {
      const { data, succ, msg } = await getsysCurrencyType()
      if (succ) {
        this.codCurrencyType = data
        this.formData.currencyCode = this.codCurrencyType[0].coding
        this.formData.currencyName = this.codCurrencyType[0].name
      } else {
        this.$message.error(msg)
      }
    },
    findDataObj (arr, val, key = 'id') {
      return arr.find(item => item[key] === val)
    },
    changeCodCurrency (val) {
      const obj = this.findDataObj(this.codCurrencyType, val, 'code')
      this.formData.currencyCode = obj.code
      this.formData.currencyName = obj.name
    },
  }
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 650px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 10px 20px 20px;
  }
}
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;
}
</style>
